import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'component/utils/Modal'
import ApproversRemoveContent from 'component/usageConsumptionApprovers/ApproversRemoveContent'

const REMOVE = 'MISSION_REMOVE'

class ApproversModal extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    modalType: PropTypes.string.isRequired,
    onSubmit: PropTypes.func,
    values: PropTypes.object,
    openEditModal: PropTypes.func,
    menuMission: PropTypes.object,
    initialValues: PropTypes.object,
    user: PropTypes.object,
  }

  constructor(props) {
    super(props)

    this.state = {
      size: 'sm',
    }

    this.renderContent = this.renderContent.bind(this)
  }

  componentWillMount() {
    const { modalType } = this.props

    if (modalType === REMOVE) {
      this.setState({ size: 'xs' })
    }
  }

  renderContent(props) {
    const newProps = {
      ...props,
    }

    if (props.modalType === REMOVE) {
      return <ApproversRemoveContent {...newProps} />
    }
  }

  render() {
    const { size } = this.state

    return (
      <Modal closeModal={this.props.closeModal} size={size}>
        {this.renderContent(this.props)}
      </Modal>
    )
  }
}

export default ApproversModal
